import { useAppSelector } from 'app/hooks';
import { isEntitlementAvailable } from 'utils';
import {
  selectIsUserAgent,
  selectUserFeatures,
} from 'services/session/sessionSelectors';
import { SERVICE_ENTITLEMENTS_MAPPING } from 'utils/service-entitlements-config';
import type { ServicesType } from 'utils/globalTypes';

function useIsFeatureAvailable(
  service: ServicesType | string[],
  agentCheckRequired = true,
) {
  const userFeatures = useAppSelector(selectUserFeatures);
  const isAgent = useAppSelector(selectIsUserAgent);

  const serviceEntitlements = Array.isArray(service)
    ? service
    : SERVICE_ENTITLEMENTS_MAPPING[service as ServicesType];

  return (
    serviceEntitlements?.some((entitlement) =>
      isEntitlementAvailable({
        userFeatures,
        entitlement,
        isAgent,
        agentCheckRequired,
      }),
    ) ?? false
  );
}

export default useIsFeatureAvailable;
